import { isArray, intersection } from 'lodash';

const globalOptions = {
  on: import.meta.env.VITE_LOGGER_ON === 'false' ? false : true,
  excludeTags: import.meta.env.VITE_LOGGER_EXCLUDE_TAGS?.split(' ') || [],
};

export default function logger(input, options = {}) {
  const { on = true, tags } = options;

  if (!globalOptions.on) return;
  if (!on) return;
  if (intersection(globalOptions.excludeTags, tags).length > 0) return;

  isArray(input) ? console.log.apply(console, input) : console.log(input);
}
